'use es6';

export default {
  SHORT: 'short',
  MEDIUM: 'medium'
};